import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  standalone: true,
  name: 'StockLevel'
})
export class StockLevel implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(stockLevel: number): string {
    if(stockLevel == 0) {
      return this.translate.instant('common.stock-levels.empty');
    } else if (stockLevel === 100) {
      return this.translate.instant('common.stock-levels.high');
    } else if (stockLevel > 50) {
      return this.translate.instant('common.stock-levels.medium');
    } else {
      return this.translate.instant('common.stock-levels.low');
    }
  }
}
